import { FunctionComponent } from 'react';
import { IconTableSeating } from '@tock/icons';
import { Typography, TypographyProps } from 'omakase';

export interface ReservationSeatingAreaDetailProps {
  seatingAreaName?: string;
  typographyVariant?: TypographyProps['variant'];
}

export const ReservationSeatingAreaDetail: FunctionComponent<ReservationSeatingAreaDetailProps> = ({
  seatingAreaName,
  typographyVariant = 'body02',
}) => {
  return (
    <li>
      <IconTableSeating />
      <Typography
        component="span"
        variant={typographyVariant}
        color="fgDefault"
        data-testid="seating-area-info"
      >
        {seatingAreaName}
      </Typography>
    </li>
  );
};
